export class Blog {
    constructor(public topic:string,public Author:string,public Date:string,public img:string){}
}
